import React from 'react';
import * as styles from '../css/paragraph.css';

const Paragraph: React.FC = ({ children }) => (
    <p className={styles.root}>
        {children}
    </p>
);

export default Paragraph;
